import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import GuardImage from 'shared/images/guard.webp'
import { Button } from 'shared/ui/button'
import { ImageOptimized } from 'shared/ui/image-optimized'

import { InsurancePolicyholderKind } from '../../model/types'

import s from './styles.module.scss'

interface PolicyholderChoiceDialogProps {
  onSelect: (kind: InsurancePolicyholderKind) => void
}

export const PolicyholderChoiceDialog: FC<PolicyholderChoiceDialogProps> = ({
  onSelect,
}) => {
  const { t } = useTranslation()

  return (
    <div className={s.dialog}>
      <ImageOptimized
        src={GuardImage}
        width={72}
        height={84}
        wrapperClassName={s.image}
        objectFit="contain"
        priority
      />

      <div className={s.textBlock}>
        <h2 className={clsx(s.title, 'bold-20')}>
          {t('insurance.vzr.policyholder.choice.title')}
        </h2>
        <p className={clsx(s.description, 'medium-14')}>
          {t('insurance.vzr.policyholder.choice.description')}
        </p>
      </div>

      <div className={s.buttons}>
        <Button
          type="button"
          className={clsx(s.button, 'bold-17')}
          onClick={() => onSelect('self')}
        >
          {t('insurance.vzr.policyholder.choice.self')}
        </Button>
        <Button
          type="button"
          variant="transparentBlue"
          className={clsx(s.button, 'bold-17')}
          onClick={() => onSelect('other')}
        >
          {t('insurance.vzr.policyholder.choice.other')}
        </Button>
      </div>
    </div>
  )
}
